export const setAFCustomerId = (userId: string) =>
  window.AF?.('pba', 'setCustomerUserId', `'${userId}'`);

export const sendAFEvent = (eventName: string, eventParams: any) =>
  window.AF?.('pba', 'event', {
    eventType: 'EVENT',
    eventName: eventName,
    eventValue: eventParams,
  });
